//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Privs from '@/components/userPanel/Privs';
import { mapState } from 'vuex';
import OpenVipTag from "./OpenVipTag.vue";
export default {
  name: 'UnLogin',
  components: {
    Privs: Privs,
    OpenVipTag: OpenVipTag
  },
  computed: mapState({
    advInfo: function advInfo(state) {
      return state.adv.btnPayMark;
    }
  })
};